import { useState as e, useEffect as r } from "react";
import o from "resize-observer-polyfill";
export default function (t, i, n) {
  if (void 0 === i && (i = 1), void 0 !== n && n <= i) throw new Error("The second width value, " + n + ", is not larger than " + i + ". Please provide a value greater than first width value");
  var a = e(!1),
      d = a[0],
      v = a[1];
  return r(function () {
    var e;
    return t ? (e = new o(function (e) {
      var r = e[0],
          o = r.borderBox ? r.borderBox.inlineSize : r.contentRect.width;
      v(void 0 !== n ? o >= i && o <= n : o <= i);
    })).observe(t) : v(!1), function () {
      e && e.disconnect();
    };
  }, [v, t, i, n]), d;
}